import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import { Holiday } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import HolidayForm from './HolidayForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditHoliday',
  props: {
    holiday: {}
  },
  setup(__props: any) {

    const props = __props;

    const form = useForm({
        name: props.holiday.name,
        holiday_date: props.holiday.holiday_date,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.salary.holidays.update', _ctx.holiday.id),
    method: "patch",
    "query-key": [_unref(QueryKey).HOLIDAYS],
    title: "holidays.update"
  }, {
    default: _withCtx(() => [
      _createVNode(HolidayForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})